import React from "react";
import { Users, Backpack } from "lucide-react";

const PriceGridCards = ({ data, theme = "default" }) => {
  const isMamba = theme === "mamba";
  return (
    <div className="space-y-3">
      {data != undefined &&
        data !== null &&
        data.map((group, index) => (
          <div
            key={group?.group_name || index}
            className={
              isMamba
                ? "bg-gradient-to-br from-white to-mamba-bg-light border-2 border-mamba-sky-blue/30 rounded-2xl p-5 hover:border-mamba-golden transition-all hover:shadow-md"
                : "bg-gradient-to-br from-slate-50 to-white border-2 border-slate-200 rounded-2xl p-5 hover:border-emerald-300 transition-all hover:shadow-md"
            }
          >
            {/* Package Header */}
            <div className="flex items-center gap-3 mb-4">
              <div
                className={
                  isMamba
                    ? "w-10 h-10 bg-gradient-to-br from-mamba-sky-blue/20 to-mamba-navy/20 rounded-full flex items-center justify-center"
                    : "w-10 h-10 bg-gradient-to-br from-emerald-100 to-teal-100 rounded-full flex items-center justify-center"
                }
              >
                {isMamba ? (
                  <Backpack className="w-5 h-5 text-mamba-navy" />
                ) : (
                  <Users className="w-5 h-5 text-emerald-600" />
                )}
              </div>
              <div className="flex-1">
                <h4 className={isMamba ? "font-black text-lg text-mamba-navy" : "font-black text-lg text-slate-900"}>
                  {group?.group_name}
                </h4>
                <p className={isMamba ? "text-xs text-mamba-navy/70" : "text-xs text-slate-500"}>
                  {group?.tiers?.length || 0} pricing tier{group?.tiers?.length !== 1 ? 's' : ''}
                </p>
              </div>
            </div>

            {/* Pricing Tiers */}
            <div className="space-y-2">
              {group?.tiers?.map((tier, tierIndex) => (
                <div
                  key={tier.tier_name || tierIndex}
                  className={
                    isMamba
                      ? "flex items-center justify-between p-3 bg-white rounded-xl border border-mamba-sky-blue/20 hover:border-mamba-golden/50 transition-all"
                      : "flex items-center justify-between p-3 bg-white rounded-xl border border-slate-100 hover:border-emerald-200 transition-all"
                  }
                >
                  <div className="flex items-center gap-2">
                    <div className={isMamba ? "w-2 h-2 bg-mamba-golden rounded-full" : "w-2 h-2 bg-emerald-500 rounded-full"} />
                    <span className={isMamba ? "text-sm font-bold text-mamba-navy" : "text-sm font-bold text-slate-700"}>
                      {tier.tier_name}
                    </span>
                  </div>

                  <div className="flex items-baseline gap-1">
                    <span className={isMamba ? "text-lg font-black text-mamba-navy" : "text-lg font-black text-emerald-600"}>
                      {tier.amount}
                    </span>
                    <span className={isMamba ? "text-xs font-semibold text-mamba-sky-blue" : "text-xs font-semibold text-slate-500"}>
                      {tier.currency}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
    </div>
  );
};

export default PriceGridCards;
